module.exports = __webpack_public_path__ + "a0f54d78c08916b465eba4e30173b614.pdf";